<script>
import Layout from '@layouts/main';
import VipForm from '@views/vips/form';

export default {
  components: {
    Layout,
    VipForm,
  },
  page() {
    return {
      title: this.$t('titles.create_vip'),
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.home'),
          to: { name: 'home.index' },
        },
        {
          text: this.$t('titles.vips'),
          to: { name: 'vips.index' },
        },
        {
          text: this.$t('titles.create_vip'),
          active: true,
        },
      ],
    };
  },
  methods: {
    create() {
      this.$router.push({
        name: 'vips.index',
      });
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <b-card
      :border-variant="!errors.items.length ? 'dark' : 'danger'"
      :header="$t('titles.create_vip')"
      header-tag="header"
      :header-bg-variant="!errors.items.length ? 'dark' : 'danger'"
      header-text-variant="white"
      class="mb-3"
    >
      <VipForm @submitted="create" />
    </b-card>
  </Layout>
</template>
